import { render, staticRenderFns } from "./platdealprocess.vue?vue&type=template&id=b90e4aae&"
import script from "./platdealprocess.vue?vue&type=script&lang=js&"
export * from "./platdealprocess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports